<section id="content">
  <div class="content-wrap m-0 p-0">
    <div class="parallax">
      <div class="section my-0 p-t-65 m-b-60">
        <div class="container">
          <div class="row">
            <div class="col-12 p-l-0 p-r-0">
              <h3 class="border-page-title">{{ 'Login' | translate }}</h3>
            </div>
          </div>
          <div class="row col-mb-100">
            <div class="ma-box center-container" [ngStyle]="isQP23 ? { color: 'var(--mainColor26)' } : {}">
              <app-login-form
                presentation="page"
                (success)="onLoginSuccess($event)"
                (error)="onLoginError($event)"
                (accountSuspended)="onAccountSuspended($event)"
                (forgotCredentialClick)="onForgotCredential($event)"
                (signupClick)="onSignup()"
              ></app-login-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
